var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernetOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1701_33796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1701_33796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 18.3333V15.8333L4.1665 10.8333V5.83329H4.99984V3.33329C4.99984 2.87496 5.16303 2.4826 5.48942 2.15621C5.81581 1.82982 6.20817 1.66663 6.6665 1.66663H13.3332C13.7915 1.66663 14.1839 1.82982 14.5103 2.15621C14.8366 2.4826 14.9998 2.87496 14.9998 3.33329V5.83329H15.8332V10.8333L13.3332 15.8333V18.3333H6.6665ZM6.6665 5.83329H8.33317V4.16663H9.1665V5.83329H10.8332V4.16663H11.6665V5.83329H13.3332V3.33329H6.6665V5.83329ZM8.33317 16.6666H11.6665V15.4166L14.1665 10.4166V7.49996H5.83317V10.4166L8.33317 15.4166V16.6666Z",
    fill: "#66BB6A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernetOnline);
export default __webpack_public_path__ + "static/media/ethernet_online.adbcd3eaef96ca5e0d2506f28954c75a.svg";
export { ForwardRef as ReactComponent };